import { useEffect, useRef } from 'react';

import { useCreateReferral } from '@/api/endpoints/user/useUserReferral';
import { useAuth } from '@/context/AuthProvider';

export const PendingReferralHandler: React.FC = () => {
  const { isAuthenticated, user } = useAuth();
  const createReferralMutation = useCreateReferral();
  const hasProcessedRef = useRef(false); // Prevent duplicate processing

  useEffect(() => {
    const processPendingReferral = async () => {
      if (!isAuthenticated || !user || hasProcessedRef.current) return;

      // Check for pending referral data in localStorage
      const pendingReferralStr = localStorage.getItem('pendingReferral');
      if (!pendingReferralStr) return;

      try {
        const pendingReferral = JSON.parse(pendingReferralStr);
        
        // Mark as processing to prevent duplicates
        hasProcessedRef.current = true;
        
        // Create the referral record in the database
        await createReferralMutation.mutateAsync({
          referralType: pendingReferral.referralType,
          referralId: pendingReferral.referralId,
          referralUrl: pendingReferral.referralUrl,
          referralMetadata: pendingReferral.referralMetadata,
        });

        // Clear the pending referral from localStorage
        localStorage.removeItem('pendingReferral');

        // Store the referral URL for redirect after onboarding (if needed)
        // Don't redirect immediately as user might be in onboarding flow
        localStorage.setItem('postOnboardingRedirect', pendingReferral.referralUrl);
      } catch (error) {
        // Failed to process pending referral
        // Clear invalid data
        localStorage.removeItem('pendingReferral');
      }
    };

    processPendingReferral();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, user?.id]); // Intentionally omit mutations to prevent loops

  return null;
};